<template lang="html">
  <v-page class="client contract" :profile="profile">

    <v-topbar :profile="profile" />
    <v-breadcrumb :steps="[
      {label:'Profissionais', to: {name:'client-vibbrants'}},
      {label: contract.vibbrante.name + ' ' + contract.vibbrante.lastname }
    ]"/>

    <div v-show="showingExportModal" class="export-modal">
      <div class="export-modal-overlay" @click.self="closeExportModal"></div>
      <div class="export-modal-content">
        <div class="export-modal-header">
          <h5>Exportar</h5>
          <button class="close-button" @click="closeExportModal">&times;</button>
        </div>
        <div class="p-3">
          <v-row>
            <v-col :md="6">
              <v-input
                type="datepicker"
                :dateFormat="'dd/MM/yyyy'"
                label="Data Início"
                v-model="exportDateRange.start"
              />
            </v-col>
            <v-col :md="6">
              <v-input
                type="datepicker"
                :dateFormat="'dd/MM/yyyy'"
                label="Data Fim"
                v-model="exportDateRange.end"
              />
            </v-col>
          </v-row>
          <v-button
            class="primary mt-3"
            :disabled="!exportDateRange.start || !exportDateRange.end"
            @click="exportToExcel"
          >
            Exportar
          </v-button>
        </div>
      </div>
    </div>

    <v-container>
      <v-alert close v-if="contract.release_hours === 0">
        <strong>Você não possui créditos para esse Vibbrante</strong><br>
        É necessário comprar créditos para ter horas liberadas para o Vibbrante trabalhar.
        Sugerimos a compra de créditos que libere horas suficientes para pelo menos 2 semanas de trabaho do Vibbrante. <v-link :to="{name:'client-wallet'}">Acesse a sua carteira para comprar créditos</v-link>
      </v-alert>
      <v-row class="size-2">
        <v-col :md="4">
          <v-card class="p-3">
            <v-avatar
              @click="openVibbranteNewTab(contract.vibbrante)"
              :name="contract.vibbrante.name + ' ' + contract.vibbrante.lastname"
              :about="contract.vibbrante.profile + '<br>' + contract.vibbrante.focus"
              class="pointer"
              :image="contract.vibbrante.avatar_old"
            >
            </v-avatar>
            <v-list class="user-profile mt-3">
              <v-text tag='div'>Status:
                <span v-if="contract.status === 'active'">Ativo</span>
                <span v-if="contract.status === 'closed'">Finalizado</span>
              </v-text>
              <v-text tag='div' v-if="!user.hide_value_hour">Valor/hora do contrato:
                <span v-if="contract.hour_value != contract.expected_hour_value" :title="'desconto ' + calcDiscount(contract.hour_value, contract.expected_hour_value) | currency">
                  <small><s>{{contract.expected_hour_value | currency }}</s></small> {{contract.hour_value | currency }}
                </span>
                  <span v-else>
                    {{contract.hour_value | currency }}
                  </span>
                </span>
              </v-text>
            </v-list>
            <v-divider line/>
            <v-list class="user-profile">
              <v-text tag='div'>Email: <span>{{ contract.vibbrante.email }}</span></v-text>
              <v-text tag='div'>Celular: <span>{{ contract.vibbrante.cel_phone }}</span></v-text>
              <v-text tag='div'>Skype: <span>{{ contract.vibbrante.skype }}</span></v-text>
              <v-text tag='div'>Hangouts: <span>{{ contract.vibbrante.hangouts }}</span></v-text>
            </v-list>
            <v-divider line/>
            <v-list class="user-profile">
              <v-text tag='div'>Data de início: <span>{{ contract.expected_start_date | moment('DD/MM/YYYY')}}</span></v-text>
              <v-text tag='div'>Previsão de conclusão:
                <span>
                  {{contract.prev_closed_contract | moment('DD/MM/YYYY')}}
                  <v-helper class="text-muted" title="Previsão de conclusão" placement="top">
                    Data calculada com base no volume de horas estimadas e na disponibilidade de horas semanais do Vibbrante.
                  </v-helper>
                </span>
              </v-text>
            </v-list>
            <v-divider line :size="3"/>
            <v-button  v-if="contract.status === 'active'" class="primary block" :size="2" @click="contract_new_hours_modal_show = true">Contratar mais horas</v-button>
            <v-button v-if="!user.hide_value_hour" class="gray block mt-3" :size="2" @click="goToContract(contract)">Ver contrato</v-button>
            <v-button class="gray block mt-3" :size="2" v-if="contract.status != 'closed'" @click="requestCloseContract()">Finalizar contrato</v-button>
            <small slot="top-left" class="badge badge-success" v-if="contract.vibbrante.vibbrante_type == 'vibbrante'">{{contract.vibbrante.vibbrante_type}}!</small>
            <small slot="top-left" class="badge badge-light" v-if="contract.vibbrante.vibbrante_type == 'freelancer'">{{contract.vibbrante.vibbrante_type}}</small>
            <v-stars :stars="contract.vibbrante.score" slot="top-right" v-if="contract.vibbrante.vibbrante_type == 'vibbrante'"></v-stars>
          </v-card>
        </v-col>
        <v-col :md="8">
          <v-card class="mb-3">
            <v-hours-display :contract="contract"/>
          </v-card>
          <v-card class="mb-3" v-if="showBlockClosedSprint === true">
            <div class="p-3 d-flex justify-content-between align-items-center" v-for="debit in contract.contract_debits">
              <div v-if="debit.status !== 'open'">
                <span>
                  <strong>{{debit.sprint_name}} <span v-if="debit.status == 'closed'">finalizada!</span></strong>
                  <small>De {{debit.opening_date | moment('DD/MM')}} à {{debit.closing_date | moment('DD/MM')}} </small> - <small><b>{{debit.work_hours}} horas</b></small>
                </span>
                <span v-if="debit.status === 'closed' ">
                  <v-link @click="changeSelectedSprint(debit.sprint_name)">Ver horas</v-link>
                  <v-button class="green ml-2" :size="1" @click="authPayment(contract.id, debit.id)">Aprovar pagamento</v-button>
                </span>
                <span v-else>
                  <v-text>Pagamento realizado</v-text>
                </span>
              </div>
            </div>
            <div class="p-3 d-flex justify-content-between align-items-center">
              <span>
                <v-alert>
                  Revise as horas reportadas nessa sprint e então aprove o pagamento para que possamos acertar com o Vibbrante. Evite demorar mais do que <strong>2 dias corridos</strong> para a aprovação.
                </v-alert>
              </span>
            </div>
          </v-card>
          <v-card>
            <v-text slot="title" tag="h5" class="d-flex align-items-center">
              Acompanhamento de horas
              <v-button
                v-if="selected_sprint && selected_sprint.sprint_name"
                class="ml-2"
                :size="2"
                @click="showExportModal"
              >
                <i class="fas fa-file-excel"></i> Exportar
              </v-button>
              <v-input class="m-0 ml-auto" type="select" v-model="current_sprint" :options="sprints_options"/>
            </v-text>

            <v-list class="list-block">
              <v-item tag="li"  class="d-flex justify-content-between align-items-center bg-light">
                <b>
                  {{ selected_sprint.sprint_name }}: <small>de  {{ selected_sprint.opening_date | moment('DD/MM/YYYY') }} à  {{ selected_sprint.closing_date | moment('DD/MM/YYYY') }}</small>
                </b>
                <small> <b>{{selected_sprint.work_hours}} trabalhadas</b></small>
              </v-item>
              <div v-if="selected_sprint.tasks.length > 0" >
                <v-item tag="li" v-for="task in selected_sprint.tasks" class="d-md-flex justify-content-between align-items-center">
                  <span class="">
                    <div class="">
                      {{ task.description }}
                    </div>
                    <small>{{ task.task_date | moment('DD/MM/YYYY')}}</small>
                  </span>
                  <span class="">
                    <v-link v-if="task.status == 'waiting_client_approved' && contract.status != 'closed'" @click="showRequestHour(task.id, task.description)">Solicitar revisão de horas</v-link>
                    <small v-if="task.status == 'review_request_by_client' " >Solicitação enviada em {{ task.last_comment.created_at | moment('DD/MM/YYYY') }} às {{ task.last_comment.created_at | moment('HH:mm') }} - </small>
                    <v-link v-if="task.status == 'review_request_by_client' && contract.status != 'closed'" @click="showRequestHour(task.id, task.description, task.status)">Ver</v-link>

                    <small v-if="task.status == 'accepted' " >Solicitação resolvida - </small>
                    <v-link v-if="task.status == 'accepted' && contract.status != 'closed'" @click="showRequestHour(task.id, task.description, task.status)">Ver</v-link>

                    <span class="badge badge-primary badge-pill">{{task.hours}}:{{task.minutes}}h</span>
                  </span>
                </v-item>
              </div>
              <div v-else>
                <v-text>
                  Nenhum apontamento de horas até o momento
                </v-text>
              </div>
            </v-list>

          </v-card>
        </v-col>
      </v-row>
    </v-container>

    <!-- MODALS -->
    <v-modals
      name="user"
      :show="user_modal_show"
      :data="{user:selected_vibbrante}"
      @onHide="user_modal_show = false"
    />
    <v-help
      name="help-close-contract"
      :show="help_modal_show"
      :data="{option: 'Finalização de contrato', contract_id: contract.id}"
      :profile="profile"
      @onHide="help_modal_show = false"
    />
    <v-contract-new-hours
      name="contract-new-hours"
      :show="contract_new_hours_modal_show"
      :data="{contract: contract}"
      @onHide="contract_new_hours_modal_show = false"
      @onRequestCredit="requestNewCredits"
    />
    <v-request-credit
      name="request-credit"
      :show="request_credit_modal_show"
      :data="{contract: contract, hours: request_credit_hours}"
      @onHide="request_credit_modal_show = false"
    />
    <v-hour-review
      name="revise-hours"
      :show="revise_new_hours_modal_show"
      profile="client"
      :data="{comments: comments, task_id: task_id, task_description: task_description, task_status: task_status, comment_from: 'client'}"
      @onHide="revise_new_hours_modal_show = false"
      @createTaskComment="createTaskComment"
      @resolvedTask="resolvedTask"
    />
    <v-rating-modal
      @onHide="onHideRatingModal"
      :show="showRating"
      :data="ratingData"
      :loading="loadingRating"
      :contractId="contract.id"
    />
  </v-page>
</template>

<script>

  import HoursDisplay from '../../../modules/hours-display'
  import apiClient from '@/api/client'
  import apiRating from '@/api/rating'
  import HelpModal from '@/parts/modals/help'
  import HourReviewModal from '@/parts/modals/hour-review'
  import ContractNewHoursModal from '@/parts/modals/contract-new-hours'
  import RequestCreditModal from '@/parts/modals/request-credit'
  import * as XLSX from 'xlsx'

  export default {
    props: {
      profile: String
    },
    components: {
      'v-hours-display': HoursDisplay,
      'v-help': HelpModal,
      'v-hour-review': HourReviewModal,
      'v-contract-new-hours': ContractNewHoursModal,
      'v-request-credit': RequestCreditModal
    },
    data() {
      return {
        vibbrante_id: null,
        sprints: [],
        showRating: false,
        ratingData: {},
        loadingRating: false,
        pago: false,
        contract_finalize_modal_show: false,
        contract_new_hours_modal_show: false,
        revise_new_hours_modal_show: false,
        request_credit_modal_show: false,
        user_modal_show: false,
        comments: [],
        selected_vibbrante: {},
        task_id: 0,
        task_description: '',
        help_modal_show: false,
        selected_sprint: {
          tasks: []
        },
        sprints_options: [],
        show_closed_sprint: false,
        current_sprint: '',
        task_status: '',
        request_hours: 0,
        showingExportModal: false,
        exportDateRange: {
          start: '',
          end: ''
        },
      }
    },
    created() {
      this.fetchData()
      this.fetchClientBalances()
    },
    watch: {
      current_sprint(newSprint) {
        this.changeSelectedSprint(newSprint)
      }
    },
    methods: {
      onHideRatingModal() {
        this.fetchData()
        this.showRating = false
      },
      createRatingForVibbrant() {
        apiRating.createRating(
          {
            event: 'close_sprint',
            vibbrante_id: this.vibbrante_id,
            client_id: this.$store.getters.user.id,
            rating_id: 3,
            origin: 'vibbrante',
            contract_id: this.$route.params.id
          }
        )
      },
      fetchRatingSprint() {
        this.loadingRating = true
        apiRating.fetch_csat_client_close_sprint()
          .then((response) => {
            if (response.data) {
              this.showRating = true
              this.ratingData = response.data
            }
          })
          .catch((error) => {
            this.$notify(error, 'error')
          })
          .finally(() => {
            this.loadingRating = false
          })
      },
      createTaskComment() {
        this.fetchData()
      },
      resolvedTask() {
        this.fetchData()
      },
      authPayment(contract_id, debit_id) {
        apiClient.clientPaySprint(contract_id, debit_id).then(async (response) => {
          this.fetchClientBalances()
          if (response.status === 200) {
            await this.fetchData()
            if (this.sprints.filter(s => s.status === 'closed').length === 0) {
              this.fetchRatingSprint()
              this.createRatingForVibbrant()
            }
          }
        }).catch((e) => {
          this.$notify(e, 'error')
        })
      },
      goToContract(contract) {
        this.$router.push({ name: 'client-contract', params: { id: contract.id } })
      },
      pagoAteAqui(n) {
        this.pago = n
      },
      calcDiscount(hour_value, expected_hour_value) {
        return (100 * (expected_hour_value - hour_value)) / expected_hour_value
      },
      changeSelectedSprint(sprint) {
        this.current_sprint = sprint
        this.contract.contract_debits.forEach((element) => {
          if (element.sprint_name === sprint) {
            this.selected_sprint = element
          }
        })
      },
      fetchData() {
        return new Promise((resolve, reject) => {
          apiClient.clientGetContract(this.$route.params.id).then((response) => {
            if (response.status === 200) {
              this.vibbrante_id = response.data.vibbrante_id
              this.$store.dispatch('loadClientCurrentContract', response.data)
              this.selected_sprint = response.data.current_sprint
              this.current_sprint = response.data.current_sprint.sprint_name
              this.sprints_options = []
              this.show_closed_sprint = false
              this.sprints = response.data.contract_debits
              response.data.contract_debits.forEach((element) => {
                this.sprints_options.push(element.sprint_name)
                if (element.status === 'closed') {
                  this.show_closed_sprint = true
                }
              })

              // Abrir a modal de review ser for o caso
              if (this.$route.params.task !== undefined) {
                this.task_id = this.$route.params.task
                response.data.tasks.forEach((task) => {
                  if (task.id === this.task_id) {
                    this.task_description = task.description
                  }
                })

                apiClient.clientTaskComment(this.$route.params.task).then((response) => {
                  if (response.status === 200) {
                    this.comments = response.data
                    this.revise_new_hours_modal_show = true
                  }
                }).catch((e) => {
                  reject()
                  this.$notify(e, 'error')
                }).finally(() => {
                  resolve()
                })
              }
            }
          }).catch((e) => {
            reject()
            this.$notify(e, 'error')
          }).finally(() => { resolve() })
        })
      },
      fetchClientBalances() {
        apiClient.clientBalances().then((response) => {
          if (response.status === 200) {
            this.$store.dispatch('loadClientBalance', response.data)
          }
        }).catch((e) => {
          this.$notify(e, 'error')
        })
      },
      showRequestHour(task_id, task_description, task_status) {
        this.task_id = task_id
        this.task_description = task_description
        this.task_status = task_status
        apiClient.clientTaskComment(task_id).then((response) => {
          if (response.status === 200) {
            this.comments = response.data
            this.revise_new_hours_modal_show = true
          }
        }).catch((e) => {
          this.$notify(e, 'error')
        })
      },
      openVibbranteNewTab(data) {
        const routeData = this.$router.resolve({
          // name: "client-search-vibbrante",
          path: '/client/search/vibbrante/' + data.slug
        })
        window.open(routeData.href, '_blank')
      },
      requestCloseContract() {
        this.help_modal_show = true
      },
      requestNewCredits(hours) {
        this.request_credit_modal_show = true
        this.request_hours = hours
      },
      showExportModal() {
        console.log('Opening modal');
        this.showingExportModal = true;
      },
      closeExportModal() {
        this.showingExportModal = false;
        this.exportDateRange = {
          start: '',
          end: ''
        };
      },
      async exportToExcel() {
        try {
          console.log({contracts: this.contract})
          // Get all tasks for the selected date range
          const tasks = [];
          const sprintTasks = this.contract.tasks.filter(task => {
              const taskDate = new Date(task.task_date);
              const startDate = new Date(this.exportDateRange.start);
              const endDate = new Date(this.exportDateRange.end);
              return taskDate >= startDate && taskDate <= endDate;
            });
            tasks.push(...sprintTasks);

          // Format tasks for Excel
          const excelData = tasks.map(task => ({
            'Data': new Date(task.task_date).toLocaleDateString(),
            'Título': task.description,
            'Horas Trabalhadas': `${task.hours}:${task.minutes}`
          }));

          // Create workbook and worksheet
          const wb = XLSX.utils.book_new();
          const ws = XLSX.utils.json_to_sheet(excelData);

          // Add worksheet to workbook
          XLSX.utils.book_append_sheet(wb, ws, 'Horas Trabalhadas');

          // Generate filename with date range
          const fileName = `horas_trabalhadas_${this.exportDateRange.start}_${this.exportDateRange.end}.xlsx`;

          // Save file
          XLSX.writeFile(wb, fileName);
          this.closeExportModal();
        } catch (error) {
          console.error('Erro ao exportar dados:', error);
        }
      },
    },
    computed: {
      user() {
        return this.$store.getters.user;
      },
      contract() {
        return this.$store.getters.client_current_contract
      },
      showBlockClosedSprint() {
        return this.show_closed_sprint
      },
      request_credit_hours() {
        return this.request_hours
      }
    }
  }

</script>

<style lang="scss">
  .client.contract {
    .timeline .avatar {
      display: inline-block;
      width: 50px;
    }
    .user-data {
      display: flex;
      justify-content: space-around;
      text-align: center;
    }
    .contract-filter {
      display: flex;
      .avatar {
        width: 60px;
        margin-right: size(2);
      }
    }
  }

  .export-modal {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 1000;
  }

  .export-modal-overlay {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.5);
  }

  .export-modal-content {
    position: relative;
    background: white;
    padding: 20px;
    border-radius: 8px;
    width: 100%;
    max-width: 500px;
    box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
    z-index: 1001;
  }

  .export-modal-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 20px;
    padding-bottom: 10px;
    border-bottom: 1px solid #eee;

    h5 {
      margin: 0;
      font-size: 1.2em;
    }
  }

  .close-button {
    background: none;
    border: none;
    font-size: 1.5em;
    cursor: pointer;
    padding: 0 5px;

    &:hover {
      color: #666;
    }
  }
</style>



// WEBPACK FOOTER //
// src/parts/pages/client/vibbrants/vibbrant.vue